import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import Login from "./components/auth/Login";
import AdminDashboard from "./components/admin/AdminDashboard";
import UserDashboard from "./components/user/UserDashboard";
import Main from "./components/user/classification/Main";
import UserFileManager from "./components/user/file_management/component/UserFileManager";
import { useAuth } from "./context/AuthContext";
import { FolderProvider } from "./context/FolderContext";

function AppRoutes() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (currentUser && !localStorage.getItem("justCreatedAccount")) {
  //     navigate("/dashboard");
  //   }
  // }, [currentUser, navigate]);

  return (
    <FolderProvider>
      <Routes>
        <Route path="/auth/login" element={<Login />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/dashboard" element={<UserDashboard />} />
        <Route path="/file-manager" element={<UserFileManager />} />
        <Route path="/classifier" element={<Main />} />
        <Route path="/" element={<Navigate to="/auth/login" />} />{" "}
        {/* The line that loads the login page first*/}
        <Route path="*" element={<Navigate to="/auth/login" />} />
      </Routes>
    </FolderProvider>
  );
}

export default function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}
